import React from "react";
import { Link } from "react-router-dom";
import { SERVER_URL } from "@/constants";
// import { EmailShareButton } from "react-share";

export const DetailsHeaderModal = ({ modal, setModal, copyTextRef }) => {
    const emailUrl = `https://www.fly-inn.com/${window.location.pathname}`;

    const handleCopy = () => {
        const input = copyTextRef.current;
        input.select();
        document.execCommand("copy");
        window.getSelection().removeAllRanges();
        setTimeout(() => {
            setModal(false);
        }, 2500);
    };

    return (
        <div
            className={`fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50 transition-opacity duration-300 ${modal ? "visible" : "invisible"}`}
        >
            <div className="relative w-full max-w-md p-6 bg-white rounded-lg shadow-lg">
                <button
                    className="absolute text-2xl text-gray-600 top-2 right-2"
                    onClick={() => setModal(false)}
                >
                    &times;
                </button>

                <div className="space-y-4">
                    <div>
                        <h3 className="text-lg font-semibold">Copy Link</h3>
                        <div className="flex items-center overflow-hidden border rounded-md">
                            <input
                                type="text"
                                className="w-full p-2 border-none outline-none"
                                defaultValue={emailUrl}
                                ref={copyTextRef}
                                readOnly
                            />
                            <button onClick={handleCopy} className="px-3 py-2 text-white bg-blue-300 rounded-md">
                                <i className="fa fa-clone"></i>
                            </button>
                        </div>
                    </div>

                    <Link to={`sms:?body=Check out this page: ${emailUrl}`}>
                        <h3 className="text-lg font-semibold">Text</h3>
                        <div className="flex items-center overflow-hidden border rounded-md">
                            <input
                                type="text"
                                className="w-full p-2 border-none outline-none"
                                defaultValue={emailUrl}
                                ref={copyTextRef}
                                readOnly
                            />
                            <button className="px-3 py-2 text-white bg-blue-300 rounded-md">
                                <i className="fa fa-message"></i>
                            </button>
                        </div>
                    </Link>


                    <Link to={`mailto:?subject=Check out this great property!&body=Click the link below to view the page:%0A${emailUrl}%0A%0AFly-Inn and Stay a While!`}>
                        <h3 className="text-lg font-semibold">Email</h3>
                        <div className="flex items-center overflow-hidden border rounded-md">
                            <input
                                type="text"
                                className="w-full p-2 border-none outline-none"
                                defaultValue={emailUrl}
                                ref={copyTextRef}
                                readOnly
                            />
                            <button className="px-3 py-2 text-white bg-blue-300 rounded-md">
                                <i className="fa fa-envelope"></i>
                            </button>
                        </div>
                    </Link>


                    {/* <div>
                        <h3 className="text-lg font-semibold">Email</h3>
                        <EmailShareButton
                            url={emailUrl}
                            subject="Check out this great property!"
                            body={`Click the link below to view the page:\n ${emailUrl}`}
                        >
                            <button className="flex items-center justify-center w-full p-3 text-white bg-blue-300 rounded-lg">
                                <MdEmail size={25} />
                            </button>
                        </EmailShareButton>
                    </div> */}
                </div>
            </div>
        </div>
    );
};